import { useEffect, useState } from 'react';

const useReviews = () => {
    const [reviews, setReviews] = useState([]);
    useEffect(() => {
        fetch('https://msm-server.onrender.com/review')
            .then(res => res.json())
            .then(data => {
                setReviews(data.reverse())
            }

            )
    }, [reviews])
    return [reviews, setReviews];
};

export default useReviews;